import { render, staticRenderFns } from "./ClientCredits.vue?vue&type=template&id=28bbce8c&"
import script from "./ClientCredits.vue?vue&type=script&lang=js&"
export * from "./ClientCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports